<template>
  <div id="app">
    <router-view v-if="show" />
    <iframe id="iframe" v-if="!show" :src="loginChannel" style="width: 0;height:0;overflow:hidden;"></iframe>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      show: false,
      loginChannel: this.$API.base.loginChannel
    }
  },
  created () {
    let _this = this
    window.addEventListener('message', function (event) {
      console.log(event)
      if (event && event.data && event.data.call && event.data.call === 'loginChannel') {
        localStorage.setItem('username', event.data.data.username)
        localStorage.setItem('usermtk', event.data.data.usermtk)
        localStorage.setItem('userInfo', event.data.data.userInfo)
        _this.show = true
      }
    }, false)
  }
}
</script>

<style lang="scss" rel="stylesheet/scss">
@import './assets/sass/base.scss';
@import './assets/icon/iconfont.css';
*{
  margin: 0;
  padding: 0;
}
html,body {
  width: 100%;
  height: 100%;
  overflow:hidden;
  font-size: 14px;
  /* line-height: 1.42857143; */
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  margin: 0;
  padding: 0;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
  overflow:hidden;
}
</style>



// WEBPACK FOOTER //
// src/App.vue